var _g, _g2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgZCharsLogo = function SvgZCharsLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 305 471",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.17507,0,0,3.17507,-3382.56,-3913.9)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(50,0,0,50,1063.65,1353.01)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.196,0.01C0.143,0.01 0.103,-0.005 0.076,-0.035C0.048,-0.065 0.034,-0.107 0.034,-0.162L0.034,-0.538C0.034,-0.593 0.048,-0.635 0.076,-0.665C0.103,-0.695 0.143,-0.71 0.196,-0.71C0.249,-0.71 0.289,-0.695 0.317,-0.665C0.344,-0.635 0.358,-0.593 0.358,-0.538L0.358,-0.464L0.254,-0.464L0.254,-0.545C0.254,-0.588 0.236,-0.61 0.199,-0.61C0.162,-0.61 0.144,-0.588 0.144,-0.545L0.144,-0.154C0.144,-0.111 0.162,-0.09 0.199,-0.09C0.236,-0.09 0.254,-0.111 0.254,-0.154L0.254,-0.261L0.358,-0.261L0.358,-0.162C0.358,-0.107 0.344,-0.065 0.317,-0.035C0.289,-0.005 0.249,0.01 0.196,0.01Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(50,0,0,50,1082.8,1353.01)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.041,-0.7L0.151,-0.7L0.151,-0.415L0.269,-0.415L0.269,-0.7L0.379,-0.7L0.379,0L0.269,0L0.269,-0.315L0.151,-0.315L0.151,0L0.041,0L0.041,-0.7Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(50,0,0,50,1103.8,1353.01)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.126,-0.7L0.275,-0.7L0.389,0L0.279,0L0.259,-0.139L0.259,-0.137L0.134,-0.137L0.114,0L0.012,0L0.126,-0.7ZM0.246,-0.232L0.197,-0.578L0.195,-0.578L0.147,-0.232L0.246,-0.232Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(50,0,0,50,1123.85,1353.01)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.041,-0.7L0.204,-0.7C0.261,-0.7 0.302,-0.687 0.328,-0.661C0.354,-0.634 0.367,-0.594 0.367,-0.539L0.367,-0.496C0.367,-0.423 0.343,-0.377 0.295,-0.358L0.295,-0.356C0.322,-0.348 0.341,-0.332 0.352,-0.307C0.363,-0.282 0.368,-0.249 0.368,-0.208L0.368,-0.085C0.368,-0.065 0.369,-0.049 0.37,-0.037C0.371,-0.024 0.375,-0.012 0.38,0L0.268,0C0.264,-0.011 0.261,-0.022 0.26,-0.032C0.259,-0.042 0.258,-0.06 0.258,-0.086L0.258,-0.214C0.258,-0.246 0.253,-0.268 0.243,-0.281C0.232,-0.294 0.214,-0.3 0.189,-0.3L0.151,-0.3L0.151,0L0.041,0L0.041,-0.7ZM0.191,-0.4C0.213,-0.4 0.23,-0.406 0.241,-0.417C0.252,-0.428 0.257,-0.447 0.257,-0.474L0.257,-0.528C0.257,-0.553 0.253,-0.572 0.244,-0.583C0.235,-0.594 0.22,-0.6 0.201,-0.6L0.151,-0.6L0.151,-0.4L0.191,-0.4Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(50,0,0,50,1144,1353.01)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.184,0.01C0.131,0.01 0.09,-0.005 0.063,-0.036C0.036,-0.066 0.022,-0.109 0.022,-0.166L0.022,-0.206L0.126,-0.206L0.126,-0.158C0.126,-0.113 0.145,-0.09 0.183,-0.09C0.202,-0.09 0.216,-0.095 0.226,-0.107C0.235,-0.117 0.24,-0.135 0.24,-0.16C0.24,-0.189 0.233,-0.215 0.22,-0.238C0.207,-0.26 0.182,-0.287 0.146,-0.318C0.101,-0.358 0.069,-0.394 0.051,-0.427C0.033,-0.459 0.024,-0.495 0.024,-0.536C0.024,-0.591 0.038,-0.634 0.066,-0.665C0.094,-0.695 0.135,-0.71 0.188,-0.71C0.241,-0.71 0.281,-0.695 0.308,-0.665C0.335,-0.634 0.348,-0.591 0.348,-0.534L0.348,-0.505L0.244,-0.505L0.244,-0.541C0.244,-0.565 0.239,-0.583 0.23,-0.594C0.221,-0.604 0.207,-0.61 0.189,-0.61C0.152,-0.61 0.134,-0.588 0.134,-0.543C0.134,-0.518 0.141,-0.494 0.155,-0.472C0.168,-0.45 0.193,-0.423 0.229,-0.392C0.275,-0.352 0.307,-0.316 0.324,-0.283C0.341,-0.25 0.35,-0.212 0.35,-0.168C0.35,-0.111 0.336,-0.067 0.308,-0.036C0.279,-0.005 0.238,0.01 0.184,0.01Z",
    style: {
      fillRule: "nonzero"
    }
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1157.79,-348.208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1463.08,418.428L1259.43,530.971L1463.08,530.971L1463.08,585.034L1157.79,585.034L1157.79,526.29L1381.34,402.749L1157.79,402.749L1157.79,348.673L1463.08,348.673L1463.08,418.428Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.22873,-1157.79,336.264)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1157.79,
    y: 348.673,
    width: 305.283,
    height: 236.361
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgZCharsLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/z-chars-logo.562872e1.svg";
export { ForwardRef as ReactComponent };